export default "__VITE_ASSET__Bh5iPV3B__"